// @flow
import React from 'react';
import Slider, { SliderTooltip } from 'rc-slider';
import moment from 'moment';
import classNames from 'classnames';

export type Props = {
  timeMarks: number[],
  value: number,
  onChange: (time: number) => void,
};

const YearRange = ({
  timeMarks,
  value,
  onChange,
}: Props): string | React$MixedElement => {
  const marks = timeMarks.sort((a, b) => a - b).map((time) => [time, time]);

  const { Handle } = Slider;

  const handleChange = (t: number) => {
    onChange(t);
  };

  const handle = ({
    value: handleValue,
    dragging,
    index,
    ...restProps
  }: {
    value: number,
    dragging: boolean,
    index: number,
  }) => (
    <SliderTooltip
      prefixCls="rc-slider-tooltip"
      overlay={
        handleValue.toString().length !== 4
          ? `${moment(handleValue).format('MM/YYYY')}`
          : handleValue
      }
      visible={true}
      placement="top"
      key={index}
      overlayClassName={classNames(
        'map-is__year-range-tooltip',
        handleValue.toString().length === 4 &&
          'map-is__year-range-tooltip--year',
        handleValue === marks[0][0] && 'map-is__year-range-tooltip--last',
        handleValue === marks[marks.length - 1][0] &&
          'map-is__year-range-tooltip--first'
      )}
    >
      <Handle value={value} {...restProps} />
    </SliderTooltip>
  );

  if (timeMarks.length < 2) {
    return '';
  }
  return (
    <div className="map-is__year-range">
      <Slider
        handle={handle}
        min={marks[0][0]}
        max={marks[marks.length - 1][0]}
        defaultValue={value || marks[marks.length - 1][0]}
        marks={Object.fromEntries(marks)}
        step={null}
        onChange={handleChange}
        dots={false}
        reverse
      />
    </div>
  );
};

export default YearRange;
